import axios from "axios";
const { ENDPOINT_API_CHATS, ENDPOINT_API_CHATBOTS } = require("@/logic/globalEndpoints")


export default {

    //++++++++++++++++ Metodo POST para CREAR Sesion Conversion +++++++++++++++++++++++++
    async create_conversation(name, contact, country, region, city, ip, id_chatbot) {

        const new_conversation_model = {
            name: name,
            contact: contact,
            country: country,
            region: region,
            city: city,
            ip: ip,
            id_chatbot: id_chatbot
        };

        const resp = await axios.post(ENDPOINT_API_CHATS + "/api/b2c/sessions/user-chatbot", new_conversation_model)
        return resp;
    },

    //++++++++++++++++ Metodo PUT para AGREGAR Info de contacto +++++++++++++++++++++++++
    async update_contact_data(name, contact, id_session) {

        const contact_data_model = {
            name: name,
            contact: contact,
            id_session: id_session
        };

        const resp = await axios.put(ENDPOINT_API_CHATS + "/api/b2c/sessions/contact-chatbot", contact_data_model)
        return resp;
    },


    //++++++++++++++++ Metodo GET para TRAER Sesion Conversion +++++++++++++++++++++++++
    async get_conversation(id_session) {

        const params = {
            id_session: id_session,
        };

        const resp = await axios.get(ENDPOINT_API_CHATS + "/api/b2c/real-time/messages", { params })
        return resp;
    },

    //++++++++++++++++ Metodo POST para ENVIAR un mensaje +++++++++++++++++++++++++
    async send_message(id_session, message, display_name, uid, role) {

        const send_message_model = {
            id_session: id_session,
            message: message,
            display_name: display_name,
            uid: uid,
            role: role
        };

        const resp = await axios.post(ENDPOINT_API_CHATS + "/api/b2c/real-time/messages", send_message_model)
        return resp;
    },

    //++++++++++++++++ Metodo GET para TRAER INFO DE UN SOLO CHATBOT +++++++++++++++++++++++++
    async get_data_chatbot(id_chatbot) {

        const params = {
            id_chatbot: id_chatbot,
        };

        const resp = await axios.get(ENDPOINT_API_CHATBOTS + "/api/b2c/data-chatbot", { params })
        return resp;
    },

    //++++++++++++++++ Metodo POST para CREAR Sesion Conversion +++++++++++++++++++++++++
    async answer_question(id_session, id_user, id_chatbot, header_chatgpt, question) {

        const params = {
            id_session: id_session,
            id_user: id_user,
            id_chatbot: id_chatbot,
            header_chatgpt: header_chatgpt,
            question: question

        };

        const headers = {
            'Content-Type': 'application/json'
        }

        const resp = await axios.post("https://prod-backend-answers-chatpro-itut4lj6tq-ue.a.run.app/questions-chatbots", params, headers)
        return resp;
    },

    //++++++++++++++++ Metodo POST para CREAR Sesion Conversion +++++++++++++++++++++++++
    async answer_question_MS(id_user, id_chatbot, header_chatgpt, temperature, question) {

        const params = {
            id_user: id_user,
            id_chatbot: id_chatbot,
            header_chatgpt: header_chatgpt,
            temperature: temperature,
            question: question

        };

        const headers = {
            'Content-Type': 'application/json'
        }

        console.log(params)
        const resp = await axios.post("https://prod-backend-answers-chatpro-itut4lj6tq-ue.a.run.app/multiple-sources/answer", params, headers)
        return resp;
    },

    //++++++++++++++++ Metodo GET para TRAER TODOS LOS CHATS DE UN USER COOKIE +++++++++++++++++++++++++
    async get_conversations_user_cookie(session_ref) {
        console.log("Start GET Conversations by ref")
        const params = {
            session_ref: session_ref,
        };

        const resp = await axios.get(ENDPOINT_API_CHATS + "/api/b2c/chats/all-chats-cookie", { params })
        return resp;
    },




}